import { IconButton } from '@material-ui/core';
import * as lib from '~/dependencies';

export const LogContactIconButton = lib.styled(IconButton)`
  position: absolute !important;
  right: 5px !important;
  top: 15px !important;
`;
